import { Component, OnInit } from '@angular/core';
import { CommonFilterService } from 'src/app/shared/services/common-filter/common-filter.service';

@Component({
  selector: 'app-network-status',
  templateUrl: './network-status.component.html',
  styleUrls: ['./network-status.component.scss']
})
export class NetworkStatusComponent implements OnInit {
  tab: number = 1;

  constructor(private commonFilterService: CommonFilterService) {
    this.commonFilterService.setNonFiltersScreen(true);
  }

  ngOnInit() {
  }

  onClick(check) {
    this.tab = parseInt(check);
    //console.log(this.tab)
  }

}
